export const DEFAULT_MODAL_SIZE = '90%';
